export default __webpack_public_path__ + "static/media/South America.dd176b21.svg";